import React, { useState } from 'react';
import './StepButton.css'

const StepButton = ({activeStep,setActiveStep,activeStepstatus}) => {
    
    
    const [name, setName] = useState('');
    const [address, setAddress] = useState('');
  
    const handleNameSubmit = () => {
      if (name.trim()) {
        setActiveStep(2);
      } else {
        alert('Please enter your name');
      }
    };
  
    return (
      <div className="unique-container">
        <div className="unique-steps">
          <button
            className={`unique-step-button ${activeStep === 1 ? 'unique-active' : ''}`}
            onClick={() => activeStep === 2 && setActiveStep(1)}
            // disabled={activeStep !== 1}
          >
            DPI-Legal+
          </button>
          <button
            className={`unique-step-button ${activeStep === 2? 'unique-active' : ''}`}
            disabled={activeStep !== 2&&activeStepstatus!==true}
            onClick={() => setActiveStep(2)}
          >
            Cyber
          </button>
        </div>
  
        {/* <div className="unique-content">
          {activeStep === 1 && (
            <div className="unique-step1">
              <label htmlFor="name">Name:</label>
              <input
                className="unique-input"
                type="text"
                id="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              <button className="unique-submit-button" onClick={handleNameSubmit}>Submit</button>
            </div>
          )}
  
          {activeStep === 2 && (
            <div className="unique-step2">
              <label htmlFor="address">Address:</label>
              <input
                className="unique-input"
                type="text"
                id="address"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
              />
            </div>
          )}
        </div> */}
      </div>
    );
  };

export default StepButton
